import PropTypes from "prop-types";

import { formatDateString } from "CrossFeatureComponents/UserRecurringGifts/Shared/formatDateString";
import PaymentTypeHandler from "Giving/ManageMyGivingPage/PaymentTypeHandler";

import FnrButton from "UI/FnrButton3";

import {
  PopoverBorder,
  PopoverButtonsContainer,
  PopoverContent,
  PopoverMessage,
  PopoverTitle,
} from "./styles";

NoticeContent.propTypes = {
  paymentType: PropTypes.string,
  nextPaymentDate: PropTypes.string,
  lastConsecutiveFailedPayments: PropTypes.array,
  handleClose: PropTypes.func,
  openEditModal: PropTypes.func,
};

export default function NoticeContent({
  paymentType,
  nextPaymentDate,
  lastConsecutiveFailedPayments,
  handleClose,
  openEditModal,
}) {
  const paymentTypeHandler = new PaymentTypeHandler(paymentType);

  const lastFailedPaymentDate = lastConsecutiveFailedPayments[0]
    ? formatDateString(lastConsecutiveFailedPayments[0])
    : null;

  return (
    <PopoverContent>
      <PopoverTitle>Failed {paymentType}</PopoverTitle>
      <PopoverBorder />
      <PopoverMessage>
        This recurring {paymentType} experienced a{" "}
        <strong>failed payment attempt</strong>
        {lastFailedPaymentDate && ` on ${lastFailedPaymentDate}`}.
        <br />
        <br />
        The next {paymentType} is scheduled for{" "}
        <strong>{nextPaymentDate}</strong>.
        <br />
        <br />
        <strong>
          <em>
            Another failed attempt will put a STOP on this recurring{" "}
            {paymentType}.
          </em>
        </strong>
        <br />
        <br />
        Click the button below to update your payment method.
      </PopoverMessage>
      <PopoverButtonsContainer>
        <FnrButton onClick={handleClose} size="small">
          Cancel
        </FnrButton>
        <FnrButton color="blue" onClick={openEditModal} size="small">
          Update {paymentTypeHandler.capitalized()}
        </FnrButton>
      </PopoverButtonsContainer>
    </PopoverContent>
  );
}
